import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaMapMarkedAlt,
  FaClock,
  FaArrowRight,
  FaExternalLinkAlt,
} from 'react-icons/fa';
import './Footer.css';

const HOURS = [
  { day: 'Lundi', time: '09h00 – 17h30' },
  { day: 'Mardi', time: '09h00 – 17h30' },
  { day: 'Mercredi', time: '09h00 – 17h30' },
  { day: 'Jeudi', time: '09h00 – 17h30' },
  { day: 'Vendredi', time: '09h00 – 17h30' },
  { day: 'Samedi', time: '09h00 – 12h00' },
  { day: 'Dimanche', time: 'Fermé', closed: true },
];

const FRENCH_DAYS = [
  'Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi',
];

const Footer = () => {
  const now = new Date();
  const year = now.getFullYear();
  const today = FRENCH_DAYS[now.getDay()];

  return (
    <footer className="footer">
      <div className="container footer-grid">

        {/* Brand */}
        <div className="footer-col footer-brand">
          <div className="footer-logo">
            <div className="footer-logo-icon"></div>
            <span>ATAA <strong>REALTY</strong></span>
          </div>
          <p className="footer-tagline">
            Cabinet d'expertise immobilière et de conseil au Maroc, aligné aux
            standards <strong>RICS</strong> et <strong>IVS</strong>.
          </p>
          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/in/salah-eddine-el-kacimi-mrics-rv-46214b19a/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn — Salah Eddine El Kacimi MRICS"
              title="LinkedIn — Salah Eddine El Kacimi MRICS"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.linkedin.com/company/ata%C3%A2-realty/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn — ATAA REALTY"
              title="LinkedIn — Page Cabinet ATAA REALTY"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4>Navigation</h4>
          <ul className="footer-links">
            <li><Link to="/notre-histoire"><FaArrowRight /> Notre Histoire</Link></li>
            <li><Link to="/mot-directeur"><FaArrowRight /> Mot du Directeur</Link></li>
            <li><Link to="/notre-equipe"><FaArrowRight /> Notre Équipe</Link></li>
            <li><Link to="/nos-standards"><FaArrowRight /> Nos Standards</Link></li>
            <li><Link to="/services"><FaArrowRight /> Services</Link></li>
            <li><Link to="/blog"><FaArrowRight /> Blog</Link></li>
            <li><Link to="/actualites"><FaArrowRight /> Actualités</Link></li>
            <li><Link to="/bibliotheque"><FaArrowRight /> Bibliothèque</Link></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <h4>Nos Métiers</h4>
          <ul className="footer-links">
            <li><Link to="/services"><FaArrowRight /> Expertise</Link></li>
            <li><Link to="/services"><FaArrowRight /> Conseil</Link></li>
            <li><Link to="/services"><FaArrowRight /> Études</Link></li>
            <li><Link to="/services"><FaArrowRight /> Formation</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col footer-contact">
          <h4>Contact</h4>
          <ul className="footer-contact-list">
            <li>
              <FaMapMarkerAlt />
              <div>
                <strong>Adresse</strong>
                <span>
                  NR 75 Avenue Taib Mohammed Naciri, Lot Safaa, ETG 01 NR07,
                  Hay Hassani, Casablanca (MA)
                </span>
                <a
                  href="https://maps.app.goo.gl/GLKyFSgSn64L3oAb7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-maps-link"
                >
                  <FaMapMarkedAlt /> Voir sur Google Maps
                  <FaExternalLinkAlt className="ext-icon" />
                </a>
              </div>
            </li>
            <li>
              <FaPhoneAlt />
              <div>
                <strong>Téléphone</strong>
                <a href="tel:+212522095653">+212 5 22 09 56 53 </a>
                <a href="tel:+212666948069">+212 6 66 94 80 69 </a>
                
              </div>
            </li>
            <li>
              <FaEnvelope />
              <div>
                <strong>Email</strong>
                <a href="mailto:contact@ataarealty.com">contact@ataarealty.com</a>
                <a href="mailto:salaheddine.elkacimi@ataarealty.com">salaheddine.elkacimi@ataarealty.com</a>
              </div>
            </li>
            <li>
              <FaClock />
              <div>
                <strong>Horaires de réception</strong>
                <ul className="footer-hours">
                  {HOURS.map((entry) => {
                    const isToday = entry.day === today;
                    const cls = [
                      isToday ? 'is-today' : '',
                      entry.closed ? 'is-closed' : '',
                    ].filter(Boolean).join(' ');
                    return (
                      <li key={entry.day} className={cls}>
                        <span className="hours-day">{entry.day}</span>
                        <span className="hours-time">{entry.time}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>&copy; Copyright {year} <strong>ATAA REALTY</strong>. Tous droits réservés.</p>
          <p className="footer-standards">
            Conduit en alignement avec les standards <strong>RICS</strong> et les <strong>International Valuation Standards (IVS)</strong>.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
